import {
  getHostEmbeddedAppRoute,
  isFanfestRouteForChannel,
} from "@f3/shared/embed-url";

import { joinURL } from "@/utils/url";

export function createEmbedIframeSrc({
  appOrigin,
  channelId,
  hostHref,
  integrationMode,
}: {
  appOrigin: string;
  channelId: string;
  hostHref: string;
  integrationMode?: string | null;
}): string {
  const embeddedRoute = getHostEmbeddedAppRoute(hostHref, {
    appOrigin,
    channelId,
  });
  const route =
    embeddedRoute && isFanfestRouteForChannel(embeddedRoute, channelId)
      ? embeddedRoute
      : null;

  const src = route
    ? new URL(route, appOrigin)
    : new URL(joinURL(appOrigin, channelId));

  src.searchParams.set("embed", "true");

  if (integrationMode) {
    src.searchParams.set("integration_mode", integrationMode);
  }

  return src.toString();
}
